import { useQueries } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';

import { getEventTicketDetails } from '@apiCalls';

interface ListSelectorProperties {
  events: IEvent[];
  onEventSelect: (event: IEvent) => void;
}

export const ListSelector = ({
  events,
  onEventSelect,
}: ListSelectorProperties) => {
  const [value, setValue] = useState<IEvent>();
  const ticketsData = useQueries({
    queries: events.map(event => ({
      queryKey: ['tickets', String(event.ID)],
      queryFn: () => getEventTicketDetails(event.ID),
      enabled: !!event && event.ID > 0,
    })),
  });

  const tickets = useMemo(() => {
    return ticketsData.map(query => query.data).filter(Boolean) as ITicket[][];
  }, [ticketsData]);

  const handleEventSelect = (value: IEvent) => {
    setValue(value);
    onEventSelect(value);
  };

  if (ticketsData.some(query => query.status === 'pending')) {
    return <div>Loading...</div>;
  }

  if (ticketsData.some(query => query.status === 'error')) {
    return <div>Error loading tickets</div>;
  }

  return (
    <div>
      {events.map((event, index) => {
        const eventTickets = tickets[index];
        const isAnyTicketAvailable = eventTickets?.some(
          ticket => ticket.Remaining > 0
        );
        const date = dayjs(event.Date);
        return (
          <div
            className={`checkoutEventListItem ${
              !isAnyTicketAvailable && 'isUnavailable'
            } ${value && value.ID === event.ID && ' selected'}`}
            onClick={() => {
              if (isAnyTicketAvailable) {
                handleEventSelect(event);
              }
            }}
            role='button'
            tabIndex={index}
            key={index}
          >
            <div className='eventInformation'>
              <div className='eventDescription'>
                <p className='eventDay'>{date.format('dddd')}</p>
                <span className='eventDate'>{date.format('DD MMMM YYYY')}</span>
              </div>
              <div className='calendar-icon'>
                <div className='calendar-icon-inner'>
                  <div>{date.format('DD')}</div>
                  <div className='month'>{date.format('MMM')}</div>
                </div>
              </div>
              <h3 className='isUnavailableMessage'>Not available</h3>
            </div>
          </div>
        );
      })}
    </div>
  );
};
